import React from "react";

export const AboutMe = ({ label, description }) => (
  <section className="profile section card" id="profile">
    <h2 className="section-title">{label}</h2>
    <p className="profile-description">{description}</p>
  </section>
);